import { NgModule } from '@angular/core';
import { CmdbRegisterPageInconsistenciesComponent } from './cmdb-register-page-inconsistencies.component';

@NgModule({
	declarations: [],
	imports: [CmdbRegisterPageInconsistenciesComponent],
	exports: [CmdbRegisterPageInconsistenciesComponent],
})
export class CmdbRegisterPageInconsistenciesModule {}
